import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Img from "../img/login-bg.jpg"; // Use the same background image
import * as Constants from '../Constant/constant';
import './Auth.css'; // Import the new CSS file
import SearchableSelect from '../shared/SearchableSelect';

const Register = () => {
    const [values, setValues] = useState({
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        role_id: '',
        library_id: '' // Changed from school_id to library_id
    });

    const [roles, setRoles] = useState([]); // State for roles
    const [libraries, setLibraries] = useState([]); // Changed from schools to libraries
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch roles and libraries
        const fetchData = async () => {
            try {
                const rolesResponse = await axios.get(Constants.API_PATH +`/roles_list`); // Replace with your API endpoint
                const librariesResponse = await axios.get(Constants.API_PATH +`/add_new_library_data`); // Changed API endpoint to fetch libraries
                setRoles(rolesResponse.data);
                setLibraries(librariesResponse.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    const handleInput = (event) => {
        setValues((prev) => ({
            ...prev,
            [event.target.name]: event.target.value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        axios.post(Constants.API_PATH + `/register`, { ...values, status: 0 }) // Set default status to 0
            .then(res => {
                if (res.data.message === "User  registered successfully") {
                    alert('Registration successful! Please wait for activation.');
                    navigate('/login');
                } else {
                    alert('Registration failed: ' + res.data.message);
                }
            })
            .catch(err => console.log(err));
    };

    return (
        <div className="login">
            <img src={Img} alt="image" className="login__bg" />

            <form onSubmit={handleSubmit} className="login__form">
                <h1 className="login__title">Register</h1>

                <div className="login__inputs">
                    <div className="login__box">
                        <input
                            type="text"
                            placeholder="First Name"
                            name="first_name"
                            required
                            className="login__input"
                            value={values.first_name}
                            onChange={handleInput}
                        />
                    </div>

                    <div className="login__box">
                        <input
                            type="text"
                            placeholder="Last Name"
                            name="last_name"
                            required
                            className="login__input"
                            value={values.last_name}
                            onChange={handleInput}
                        />
                    </div>

                    <div className="login__box">
                        <input
                            type="email"
                            placeholder="Email ID"
                            name="email"
                            required
                            className="login__input"
                            value={values.email}
                            onChange={handleInput}
                        />
                    </div>

                    <div className="login__box">
                        <input
                            type="password"
                            placeholder="Password"
                            name="password"
                            required
                            className="login__input"
                            value={values.password}
                            onChange={handleInput}
                        />
                    </div>

                    {/* Role Dropdown */}
                    <div className="login__box">
                        <SearchableSelect
                            name="role_id"
                            required
                            clearable={false}
                            className="login__input"
                            value={values.role_id}
                            onChange={handleInput}
                            options={roles.map((role) => ({ value: role.id, label: role.name }))}
                            placeholder="Select Role"
                        />
                    </div>

                    {/* Library Dropdown */}
                    <div className="login__box">
                        <SearchableSelect
                            name="library_id"
                            required
                            clearable={false}
                            className="login__input"
                            value={values.library_id}
                            onChange={handleInput}
                            options={libraries.map((library) => ({ value: library.id, label: library.library_name }))}
                            placeholder="Select Library"
                        />
                    </div>
                </div>

                <button type="submit" className="login__button">Register</button>

                <div className="login__register">
                    Already have an account? <Link to="/" className="login__register-link">Login</Link>
                </div>
            </form>
        </div>
    );
}

export default Register;
